/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo200,
  GetApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo401,
  GetApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo403,
  GetApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo404,
  GetApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo500,
  GetApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfoPathParams,
  GetApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfoQueryResponse,
} from "../../types/documentCourseRegistrationController/GetApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo.ts";

export const getApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfoPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
    documentId: z.coerce.number().int(),
    cultureInfo: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfoPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo200Schema =
  z.instanceof(
    File,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo401>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo403Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo403>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo404Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo500>;

export const getApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfoQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfo200Schema,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidDocumentidCultureinfoQueryResponse>;
